// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5898ebb","373":"d6e46fbb","411":"14b68563","455":"535eb936","480":"f0d21e3f","564":"2eb438d3","606":"7e686fd7","655":"388177b7","744":"9430f6bc","801":"13ca8545","809":"aa49af4e","977":"51f55cf2"}[chunkId] + ".chunk.js";
};